import { createFileRoute } from '@tanstack/react-router';
import { TrainingDashboard } from '@/pet/src/components/training/TrainingDashboard';

export const Route = createFileRoute('/dashboard/training')({
  component: PetsoTraining,
});

function PetsoTraining() {
  return <TrainingDashboard />;
}
